import { render, staticRenderFns } from "./test-form.vue?vue&type=template&id=e05f67c6&lang=html&"
import script from "./test-form.vue?vue&type=script&lang=js&"
export * from "./test-form.vue?vue&type=script&lang=js&"
import style0 from "./test-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports